<template>
  <div class="choose-users-page" data-test="choose-user__page">
    <PageHeader title="Choix fournisseur"/>
    <Card
      class="shop-users-card">
      <el-collapse-transition>
        <div class="shop-users-card__header" v-loading="loading">
          <UserItem
            v-for="supplier in suppliers"
            :key="supplier.id"
            :displayName="supplier.name"
            title=""
            @onClick="handleSupplierSelected(supplier)"
            />
        </div>
      </el-collapse-transition>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import UserItem from '@/views/pages/UserLoginPage/UserItem.vue';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import services from 'services';

export default {
  components: {
    Card,
    PageHeader,
    UserItem,
  },
  async mounted() {
    this.loading = true;
    await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      suppliers: [],
    };
  },
  methods: {
    async fetchData() {
      const shopId = this.$store.getters['shopAuth/currentShopId'];
      this.suppliers = await services.supplierService.listByShopId(shopId);
    },
    handleSupplierSelected(supplier) {
      this.$router.push({ name: 'ChooseBonDeLivraison', params: { supplierId: supplier.id } });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/main.styl';

.choose-users-page {
}
.shop-users-card {
  margin-top: 20px;
  margin-bottom: 20px;
  overflow-x: hidden;
}

.shop-users-title {
  color: $primary-color;
  position: relative;
  font-size: 2.3em;
  font-weight: 600;
  display: inline;
}
.shop-users-card__login-form {
}

</style>
